import { DocumentDownloadOptions, Fonts, TextAlignment } from '../../../../../../backend/src/types/types';
import { FONT_FAMILY_OPTIONS, TEXT_ALIGNMENT_OPTIONS } from '@/constants/downloadOptions';
import { cn } from '@/helpers/shadCnUtils';
import { Label } from '@/new/components/shadcn/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/new/components/shadcn/select';
import { Switch } from '@/new/components/shadcn/switch';

interface Props {
  value: DocumentDownloadOptions;
  onChange: (value: DocumentDownloadOptions) => void;
}

export const DocOptionsField = ({ value, onChange }: Props) => (
  <>
    <div className="flex flex-col gap-2">
      <Label className="text-sm font-medium">Font</Label>
      <Select value={value.fontFamily} onValueChange={(v) => onChange({ ...value, fontFamily: v as Fonts })}>
        <SelectTrigger>
          <SelectValue placeholder="Select font" />
        </SelectTrigger>
        <SelectContent>
          {FONT_FAMILY_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    <div className="flex flex-col gap-2">
      <Label className="text-sm font-medium">Text Alignment</Label>
      <Select
        value={value.textAlignment}
        onValueChange={(v) => onChange({ ...value, textAlignment: v as TextAlignment })}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select alignment" />
        </SelectTrigger>
        <SelectContent>
          {TEXT_ALIGNMENT_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    <div className="flex items-center justify-between">
      <div className="flex flex-col">
        <Label className="text-sm font-medium">Include References</Label>
        <span className="mt-1 text-xs text-gray-500">
          {value.includeReferences ? 'References section will be added at the end' : 'No references will be included'}
        </span>
      </div>
      <div className="flex items-center space-x-2">
        <Label
          className={cn(
            'm-0 px-2 text-sm text-gray-700 transition-colors duration-150',
            !value.includeReferences && 'text-teal-500',
          )}
        >
          No
        </Label>
        <Switch
          className="bg-gray-100"
          checked={value.includeReferences}
          onCheckedChange={(checked) => onChange({ ...value, includeReferences: checked })}
        />
        <Label
          className={cn(
            'm-0 text-sm text-gray-700 transition-colors duration-150',
            value.includeReferences && 'text-teal-500',
          )}
        >
          Yes
        </Label>
      </div>
    </div>
  </>
);
